import { FIELD_BASE_TYPES, FieldBaseTypeObject, getBaseTypeByValue } from "./BaseTypes";
import { FIELD_TYPES, FieldTypeObject, getFieldTypeByValue } from "./FieldTypes";
import { Section } from "./Section";

export interface ConditionalLogic {
  fieldId: string;
  operator: 'equals' | 'not_equals' | 'contains';
  value: string | string[];
  idConditionalLogic?: number;
  parentFieldId?: string;
  parentContenuId?: number;
  parentFieldIndex?: number | null;
}

export interface DynamicField {
  id: string;
  label: string;
  section?: Section;
  type: FieldTypeObject;
  dbType: FieldBaseTypeObject;
  options?: string[];
  optionsValues?: string[];
  placeholder?: string;
  
  conditionalLogic?: ConditionalLogic;
  cascadeFields?: string[];
}

export function normalizeDynamicField(field: DynamicField): DynamicField {
  if (!field?.type?.value) {
    return field;
  }

  const nonCalculableTypes = [
    FIELD_TYPES.SELECT.value,
    FIELD_TYPES.RADIO.value,
    FIELD_TYPES.CHECKBOX.value,
  ];

  let normalizedBaseType: FieldBaseTypeObject | undefined;

  if (nonCalculableTypes.includes(field.type.value)) {
    normalizedBaseType = FIELD_BASE_TYPES.TEXT;
  } else {
    normalizedBaseType = getBaseTypeByValue(field.type.value);
  }

  // Type non reconnu → on ne force rien
  if (!normalizedBaseType) {
    return field;
  }

  // Évite les mutations inutiles
  if (field.dbType.id === normalizedBaseType.id) {
    return field;
  }

  return {
    ...field,
    dbType: normalizedBaseType,
  };
}